import { render, staticRenderFns } from "./CariPerformans.vue?vue&type=template&id=02fe80d8&scoped=true"
import script from "./CariPerformans.vue?vue&type=script&lang=js"
export * from "./CariPerformans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fe80d8",
  null
  
)

export default component.exports